import React               from 'react';
import CompetitionTypeIcon from './CompetitionTypeIcon';
import Translations        from '../../utils/Translations';
import PropTypes           from 'prop-types';

const CompetitionsWinners = (props) =>
	<div className="competitions-completed__item">
		<img src={props.previewUrl} loading={"lazy"}/>
		<div className='competitions-completed__item--overlay'>
			<div className="competitions-completed__item--icon">{CompetitionTypeIcon(props.type)}</div>
			<div className="competitions-completed__item--type"><h3>{props.type === 'video' ? 'Video' : 'Selfie'}-{Translations.get('Vx20YearsCompetition')}</h3></div>
			<div className="competitions-completed__item--title">{props.title}</div>
		</div>
	</div>;

CompetitionsWinners.propTypes = {
	previewUrl: PropTypes.string.isRequired,
	type:       PropTypes.string.isRequired,
	title:      PropTypes.string.isRequired,
};

export default CompetitionsWinners;
